import { cn } from '@/utils/cn';

interface BoxProps {
  children: React.ReactNode;
  isSelected: boolean;
  onSelect: () => void;
}

export const Box = ({ children, isSelected, onSelect }: BoxProps) => {
  return (
    <div
      className={cn(
        'flex justify-center items-center h-14 border-1 rounded-md border-base-border cursor-pointer min-w-19 w-full transition-all duration-200 ease-out',
        isSelected &&
          'border-selected-border bg-selected-background shadow-[0_1px_1.5px_rgba(68,138,227,0.10),0_1px_1px_rgba(68,138,227,0.06)]'
      )}
      onClick={onSelect}
    >
      {children}
    </div>
  );
};
